import type { MaterialSymbolName } from '@repo/design-system/types/material-symbol-names';
import type { MapDataHeroActionIconCategory } from '@repo/types/maps/map-types';
import type { HeroActionManualEditorState } from './types';

export const HERO_ACTION_PROMPT_KEY = 'hero_action_suggestions';
export const HERO_ACTION_GENERATION_POLL_MS = 5000;
export const HERO_ACTION_GENERATION_POLL_GRACE_MS = 15000;
export const HERO_ACTION_ICON_OPTIONS: {
    label: string;
    value: MapDataHeroActionIconCategory;
    glyph: MaterialSymbolName;
}[] = [
    { label: 'Story / Lore', value: 'story_lore', glyph: 'auto_stories' },
    { label: 'Loot / Gear', value: 'loot_gear', glyph: 'shield' },
    { label: 'Collectible', value: 'collectible', glyph: 'diamond' },
    { label: 'Companion', value: 'companion', glyph: 'group' },
    { label: 'Easter Egg', value: 'easter_egg', glyph: 'egg' },
    { label: 'Combat / Boss', value: 'combat_boss', glyph: 'swords' },
];

export const NEW_HERO_ACTION_EXTERNAL_ID = 'new-hero-action-draft';
export const EMPTY_MANUAL_EDITOR_STATE: HeroActionManualEditorState = {
    name: '',
    description: '',
    iconCategory: 'loot_gear',
    priority: '0',
    resultPins: '',
    triggerPins: '',
};

export function getHeroActionIconGlyph(iconCategory: MapDataHeroActionIconCategory): MaterialSymbolName {
    return HERO_ACTION_ICON_OPTIONS.find(option => option.value === iconCategory)?.glyph ?? 'flag';
}
